
export class CreProVcuPostReq {
    serial?: string | null;
    nickname?: string | null;
    vcuAttributes?: { [key: string]: string } | null;
}
